import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
    root: {
        maxHeight: 320
    },
    item: {
        maxWidth: 320,
        padding: theme.spacing(2),
    },
    title: {
        display: 'flex',
        '& svg': {
            marginRight: theme.spacing(1)
        }
    },
    warning: {
        color: theme.palette.warning.main
    },
    error: {
        color: theme.palette.error.main
    },
    info: {
        color: theme.palette.info.main
    }
}));

export default useStyles;